import {
  Camera,
  Scene,
  SRGBColorSpace,
  Vector2,
  WebGLRenderer,
} from "three";
import { WebGPURenderer } from "three/webgpu";
import { IRenderer } from "./IRenderer";
import { GPU_POWER_PREFERENCE, logActiveWebGLGpu } from "./logActiveGpu";
import { renderSettingsStore } from "../../core/pipeline/RenderSettingsStore";

export class WebGLRendererSingleton implements IRenderer {
  render(scene: Scene, camera: Camera): void {
    this.instance.render(scene, camera);
  }

  async ensureReady(): Promise<void> {
    // Classic WebGLRenderer is ready synchronously after construction.
  }

  get isWebGPUBackend(): boolean {
    return false;
  }

  get isWebGPURenderer(): boolean {
    return false;
  }

  get supportsClassicPostProcessing(): boolean {
    return true;
  }

  screenshot(
    type: string = "image/png",
    quality: number = 1
  ): Promise<Blob | null> {
    return new Promise((resolve) => {
      this.instance.domElement.toBlob((blob: Blob | null) => resolve(blob), type, quality);
    });
  }

  get instance(): WebGLRenderer | WebGPURenderer {
    return this._render_instance;
  }

  private _render_instance: WebGLRenderer;
  private static _instance: WebGLRendererSingleton;

  private constructor() {
    this._render_instance = new WebGLRenderer({
      alpha: true,     
      antialias: false,
      precision: "highp",
      powerPreference: GPU_POWER_PREFERENCE,
      preserveDrawingBuffer: true,
      //logarithmicDepthBuffer: true,
    });
    this._render_instance.setPixelRatio(renderSettingsStore.resolvePixelRatio());
    (this._render_instance as any).physicallyCorrectLights = true;
    this._render_instance.outputColorSpace = SRGBColorSpace;
    renderSettingsStore.applyRenderer(this._render_instance);
    logActiveWebGLGpu(this._render_instance.getContext());
  }

  private _size: Vector2 = new Vector2();
  get size(): Vector2 {
    this._render_instance.getSize(this._size);
    return this._size;
  }

  public static getInstance(): WebGLRendererSingleton {
    if (!WebGLRendererSingleton._instance) {
      WebGLRendererSingleton._instance = new WebGLRendererSingleton();
    }
    return WebGLRendererSingleton._instance;
  }
}
